import { Container, Row, Col } from "react-bootstrap";

import "./Location.css";

export default function Location() {
    return (
        <Container className="location-container">
            <Row>
                <Col style={{ marginTop: '20px' }}>
                    <Row>
                        <Col>
                            <h1 style={{ marginBottom: '20px' }}>BOAC Nerede?</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p style={{fontSize: '16px'}}>BOAC Soft Serve</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <iframe title="BOAC Soft Serve" className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3012.723997880547!2d29.069577199999994!3d40.9656248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac797f592684d%3A0x31bd1cbb51037df8!2sBOAC%20Soft%20Serve!5e0!3m2!1str!2str!4v1748593939697!5m2!1str!2str" loading="lazy"></iframe>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p style={{fontSize: '16px', marginTop: '20px'}}>BOAC Soft Serve Kiosk</p>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '70px'}}>
                        <Col>
                            <iframe title="BOAC Soft Serve Kiosk" className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3012.670726850595!2d29.064483627992335!3d40.96679164324605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac774f6b0f4a5%3A0x7c9ff60b4696f306!2zQ2FkZGVib3N0YW4sIE9nw7xuIFNrLiBObzozIEQ6YSwgMzQ3MjggS2FkxLFrw7Z5L8Swc3RhbmJ1bA!5e0!3m2!1str!2str!4v1716906999716!5m2!1str!2str" loading="lazy"></iframe>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p style={{fontSize: '16px', marginTop: '20px'}}>BOAC Soft Serve Moda Kadıköy</p>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '70px'}}>
                        <Col>
                            <iframe title="BOAC Soft Serve Moda Kadıköy" className="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.859814844395!2d29.0277589!3d40.984550399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab96c59e06a67%3A0x950515f9ddb9b398!2sBOAC%20Soft%20Serve%20Moda!5e0!3m2!1str!2sus!4v1752824607732!5m2!1str!2sus" loading="lazy"></iframe>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
